<template>
    <div v-if="dictionaryLoaded">
        <fieldset class="formgrid grid">
            <div class="col-12">
                <legend>{{ dictionary.ArtistProfileAccountFormPersonalInfoHeadline }}</legend>
                <p>{{ dictionary.ArtistProfileAccountFormPersonalInfoDescription }}</p>
            </div>
            <div class="col-12 md:col-6">

                <div class="field">
                    <label :for="getInputFieldName('FullName')">{{ dictionary.ArtistProfileAccountFormNameLabel }}</label>
                    <InputText :name="getInputFieldName('FullName')" :placeholder="dictionary.ArtistProfileAccountFormNamePlaceholder" type="text" v-model="v$.model.FullName.$model"
                        :class="{ 'p-invalid': v$.model.FullName.$invalid }" />
                </div>
                <div class="field">
                    <label :for="getInputFieldName('Address')">{{ dictionary.ArtistProfileAccountFormAddressLabel }}</label>
                    <InputText :name="getInputFieldName('Address')" :placeholder="dictionary.ArtistProfileAccountFormAddressPlaceholder" type="text" v-model="model.Address" />
                </div>
                <div class="field">
                    <label :for="getInputFieldName('ZipCode')">{{ dictionary.ArtistProfileAccountFormZipCodeLabel }}</label>
                    <InputText :name="getInputFieldName('ZipCode')" :placeholder="dictionary.ArtistProfileAccountFormZipCodePlaceholder" type="text" v-model="model.ZipCode" />
                </div>
                <div class="field">
                    <label :for="getInputFieldName('City')">{{ dictionary.ArtistProfileAccountFormCityLabel }}</label>
                    <InputText :name="getInputFieldName('City')" :placeholder="dictionary.ArtistProfileAccountFormCityPlaceholder" type="text" v-model="model.City" />
                </div>
                <div class="field field-checkbox field-checkbox--aligned">
                    <Checkbox :inputId="getInputFieldName('DontAllowIndexing')"
                        :name="getInputFieldName('DontAllowIndexing')" v-model="model.DontAllowIndexing" :binary="true" />
                    <label :for="getInputFieldName('DontAllowIndexing')">{{
                        dictionary.ArtistProfileAccountFormDontAllowIndexingLabel }}</label>
                </div>
            </div>
            <div class="col-12 md:col-6">
                <div class="field">
                    <label :for="getInputFieldName('Commune')">{{ dictionary.ArtistProfileAccountFormCommuneLabel }}</label>
                    <InputText :name="getInputFieldName('Commune')" :placeholder="dictionary.ArtistProfileAccountFormCommunePlaceholder" type="text" v-model="model.Commune" />
                </div>
                <div class="field">
                    <label :for="getInputFieldName('Cvr')">{{ dictionary.ArtistProfileAccountFormCVRLabel }}</label>
                    <InputText :name="getInputFieldName('Cvr')" :placeholder="dictionary.ArtistProfileAccountFormCVRPlaceholder" type="text" v-model="model.Cvr" />
                </div>
                <div class="field">
                    <label :for="getInputFieldName('Email')">{{ dictionary.ArtistProfileAccountFormEmailLabel }}</label>
                    <InputText :name="getInputFieldName('Email')" :placeholder="dictionary.ArtistProfileAccountFormEmailPlaceholder" type="email" v-model="v$.model.Email.$model"
                        :class="{ 'p-invalid': v$.model.Email.$invalid }" />
                </div>
                <div class="field">
                    <label :for="getInputFieldName('Phone')">{{ dictionary.ArtistProfileAccountFormPhoneLabel }}</label>
                    <InputText :name="getInputFieldName('Phone')" :placeholder="dictionary.ArtistProfileAccountFormPhonePlaceholder" type="tel" v-model="model.Phone" />
                </div>
                
               
            </div>
        </fieldset>
        <fieldset class="formgrid grid">
            <div class="col-12">
                <legend>{{ dictionary.ArtistProfileAccountFormAdditionInfoHeadline }}</legend>
                <p>{{ dictionary.ArtistProfileAccountFormAdditionInfoDescription }}</p>
            </div>
            <div class="col-12">

                <div class="field">
                    <label :for="getInputFieldName('WhoIAmShort')">{{ dictionary.ArtistProfileAccountFormWhoIAmShortLabel }}</label>
                    <Textarea :name="getInputFieldName('WhoIAmShort')"
                        :placeholder="dictionary.ArtistProfileAccountFormWhoIAmShortPlaceholder"
                        v-model="v$.model.WhoIAmShort.$model"
                        :class="{ 'p-invalid': v$.model.WhoIAmShort.$invalid }"></Textarea>
                    <small>
                        {{ whoIAmShortLength }} / 140 - 
                        {{ dictionary.ArtistProfileAccountFormWhoIAmShortHelpText }}</small>
                </div>
            </div>
            <div class="col-12">
                <div class="field">
                    <label :for="getInputFieldName('WhoIAm')">{{ dictionary.ArtistProfileAccountFormWhoAmILabel }}</label>
                    <Textarea :name="getInputFieldName('WhoIAm')"
                        :placeholder="dictionary.ArtistProfileAccountFormWhoIAmPlaceholder"
                        v-model="model.WhoIAm"></Textarea>
                </div>
            </div>
            <div class="col-12">
                <div class="field">
                    <label :for="getInputFieldName('WebsiteUrl')">{{ dictionary.ArtistProfileAccountFormWebsiteLabel
                    }}</label>
                    <InputText :name="getInputFieldName('WebsiteUrl')" :placeholder="dictionary.ArtistAccountProfileFormWebsitePlaceholder" type="text" v-model="model.WebsiteUrl" />
                </div>
            </div>
            <div class="col-12 md:col-6">
                <div class="field">
                    <label>{{ dictionary.ArtistProfileAccountFormArtistTypeLabel }}</label>
                    <MultiSelect v-model="model.ArtistTypes" :options="allArtistTypes" optionLabel="Item2"
                        optionValue="Item1" placeholder="Vælg typer" class="w-full" />
                    <input type="hidden" :value="cleanedArtistTypes" :name="getInputFieldName('ArtistTypes')" />
                </div>
            </div>
            <div class="col-12 md:col-6">
                <div class="field">
                    <label>{{ dictionary.ArtistProfileAccountFormTagsLabel }}</label>
                    <MultiSelect v-model="model.Tags" :options="allArtistTags" optionLabel="Item2"
                        optionValue="Item1" placeholder="Vælg tags" class="w-full" />
                    <input type="hidden" :value="cleanedTags" :name="getInputFieldName('Tags')" />
                </div>
                
            </div>
            <div class="col-12">
                <fieldset v-if="mode == vueHelpers.createModeKey" class="field">
                    <legend>{{dictionary.ArtistProfileAccountFormProfileImageFieldsetHeadline}}</legend>
                    <p>{{ dictionary.ArtistProfileAccountFormProfileImageFieldsetDescription }}</p>
                    <label :for="getInputFieldName('ProfileImage')">{{ dictionary.ArtistProfileAccountFormProfileImage
                    }}</label>
                    <FileUpload :name="getInputFieldName('ProfileImage')" acceptTypes="image/jpeg,image/jpg"
                        :showRemoveButton="true" />
                </fieldset>
                <fieldset v-if="mode == vueHelpers.createModeKey" class="field">
                    <legend>Upload CV</legend>
                    <p>Skal uploades som PDF</p>
                    <label :for="getInputFieldName('Cv')">{{ dictionary.ArtistProfileAccountFormCVLabel }}</label>
                    <FileUpload :name="getInputFieldName('Cv')" acceptTypes="application/pdf" :showRemoveButton="true" />
                </fieldset>
            </div>
        </fieldset>

    </div>
</template>
<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import Password from 'primevue/password';
import Checkbox from 'primevue/checkbox';
import MultiSelect from 'primevue/multiselect';
import FileUpload from './fileUpload.vue';
import VueHelpers from '../vueHelpers';
import { useVuelidate } from '@vuelidate/core'
import { required, email, maxLength } from '@vuelidate/validators'

export default {
    name: "artistProfileAccountForm",
    props: ['artistModel', 'mode', 'inputKey'],
    components: {
        Button,
        InputText,
        Textarea,
        Toast,
        Checkbox,
        MultiSelect,
        Password,
        FileUpload
    },
    data() {
        return {
            dictionary: [],
            dictionaryLoaded: false,
            vueHelpers: null,
            allArtistTypes: [],
            allArtistTags: [],
            model: {
                MemberId: null,
                Address: null,
                ZipCode: null,
                City: null,
                Commune: null,
                Phone: null,
                Cvr: null,
                WebsiteUrl: null,
                WhoIAm: null,
                ArtistTypes: [],
                Tags: null,
                DontAllowIndexing: false
            },
        };
    },
    setup() {
        return { v$: useVuelidate() }
    },
    created() {
        const vm = this;
        vm.vueHelpers = VueHelpers;
        if (vm.artistModel) {
            vm.model = vm.artistModel;
        }

        fetch('/umbraco/api/resourcesApi/GetArtistProfileAccountFormDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                vm.dictionaryLoaded = true;
            })
            .catch((error) => {
                console.log(error);
                vm.dictionaryLoaded = true;
            });

        fetch('/umbraco/api/resourcesApi/GetArtistTypes').then((response) => response.json())
            .then((data) => {
                vm.allArtistTypes = data;
            })
            .catch((error) => {
                console.log(error);
            });

        fetch('/umbraco/api/resourcesApi/GetArtistTags').then((response) => response.json())
            .then((data) => {
                vm.allArtistTags = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    validations() {
        return {
            model: {
                FullName: { required },
                Email: { required, email },
                WhoIAmShort: { required, maxLengthValue: maxLength(140) }
            }
        }
    },
    methods: {
        getInputFieldName(name) {
            if (this.inputKey) {
                return this.inputKey + '.' + name.charAt(0).toUpperCase() + name.slice(1);
            }

            return name;
        },
        
    },
    computed: {
        cleanedTags() {
            if (this.model.Tags) {
                return this.model.Tags.join(',');
            }
            return null;
        },
        cleanedArtistTypes() {
            if (this.model.ArtistTypes) {
                return this.model.ArtistTypes.join(',');
            }

            return null;
        },
        whoIAmShortLength(){

            if(!this.v$.model.WhoIAmShort.$model) {
                return 0;
            }
            
            return this.v$.model.WhoIAmShort.$model.length;
        }
    }
};
</script>